import { $fetch } from '@/boot/fetch'
import { replacePathTokens } from '@/utils/routes.util'

const ENDPOINT = '/retailers/{{retailerId}}/vendors'
const CONFIG_ENDPOINT = '/retailers/{{retailerId}}/vendors/{{vendorConfigId}}'
const WAREHOUSE_ENDPOINT = '/retailers/{{retailerId}}/vendors/{{vendorConfigId}}/warehouses'
const WAREHOUSE_SINGLE_ENDPOINT = '/retailers/{{retailerId}}/vendors/{{vendorConfigId}}/warehouses/{{warehouseId}}'

export default {
  list(retailerId) {
    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId }), {
      raw: true,
    })
  },

  create(retailerId, body) {
    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId }), {
      method: 'POST',
      body,
    })
  },

  getSingle(retailerId, vendorConfigId) {
    return $fetch.peg(replacePathTokens(CONFIG_ENDPOINT, { retailerId, vendorConfigId }), {
      raw: true,
    })
  },

  update(retailerId, vendorConfigId, body) {
    return $fetch.peg(replacePathTokens(CONFIG_ENDPOINT, { retailerId, vendorConfigId }), {
      method: 'PUT',
      body,
    })
  },

  deleteSingle(retailerId, vendorConfigId) {
    return $fetch.peg(replacePathTokens(CONFIG_ENDPOINT, { retailerId, vendorConfigId }), {
      method: 'DELETE',
    })
  },

  sync(retailerId) {
    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId }) + '/sync', {
      method: 'POST',
    })
  },

  listWarehouses(retailerId, vendorConfigId) {
    return $fetch.peg(replacePathTokens(WAREHOUSE_ENDPOINT, { retailerId, vendorConfigId }), {
      raw: true,
    })
  },

  createWarehouse(retailerId, vendorConfigId, body) {
    return $fetch.peg(replacePathTokens(WAREHOUSE_ENDPOINT, { retailerId, vendorConfigId }), {
      method: 'POST',
      body,
    })
  },

  updateWarehouse(retailerId, vendorConfigId, warehouseId, body) {
    return $fetch.peg(replacePathTokens(WAREHOUSE_SINGLE_ENDPOINT, { retailerId, vendorConfigId, warehouseId }), {
      method: 'PUT',
      body,
    })
  },

  deleteWarehouse(retailerId, vendorConfigId, warehouseId) {
    return $fetch.peg(replacePathTokens(WAREHOUSE_SINGLE_ENDPOINT, { retailerId, vendorConfigId, warehouseId }), {
      method: 'DELETE',
    })
  },
}
